<template>
  <div class="ui-inline-icon"

       v-html="icons[icon]"
       :class="['ui-inline-icon', 'ui-inline-icon--'+icon, {'ui-inline-icon--circle': inCircle}]"
       :style="styles"></div>
</template>

<script>
  import Vue from 'vue'

  const icons = {
    alert: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/alert.svg'),
    arrow: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/arrow.svg'),
    arrow2: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/arrow2.svg'),
    arrowLeft: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/arrow_left.svg'),
    calendar: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/calendar-blue.svg'),
    'card-ok': require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/card-ok-blue.svg'),
    doubleArrowLeft: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/arrow_left-double.svg'),
    check: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/check.svg'),
    clock: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/clock.svg'),
    drag: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/drag.svg'),
    edit: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/edit.svg'),
    'filledarrow-up': require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/filledarrow-up.svg'),
    map_balloon: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/map_balloon.svg'),
    menu_list: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/menu_list.svg'),
    'ok-o': require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/ok-o-blue.svg'),
    'plus-o': require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/plus-o-white.svg'),
    search: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/search-gray.svg'),
    time: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/time-blue.svg'),
    trash: require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/trash.svg'),
    'remove-o-gray': require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/remove-o-gray.svg'),
    'ellipsis-white': require('!svg-inline-loader?removeSVGTagAttrs=false!src/assets/icons/ui/ellipsis-white.svg'),
  }

  export default Vue.extend({
    name: 'BzInlineIcon',
    props: {
      icon: {type: String},
      color: {type: String},
      height: {
        default: 0
      },
      inCircle: Boolean,
      background: String,
      boxShadow: String,
      borderColor: String
    },
    data () {
      return {icons}
    },
    created () {
      if (!this.icons[this.icon]) {
        console.error('icon ' + this.icon + ' undefined')
      }
    },
    mounted () {
      this.setColor()
    },
    watch: {
      color () {
        this.setColor()
      }
    },
    methods: {
      setColor () {
        for (const path of this.$el.querySelectorAll('path')) {
          if (path.attributes.getNamedItem('fill')) {
            path.style.fill = this.color ? this.color : ''
          }
          if (path.attributes.getNamedItem('stroke')) {
            path.style.stroke = this.color ? this.color : ''
          }
        }
      }
    },
    computed: {
      styles () {
        const styles = {}
        if (this.height) styles.height = this.height + 'px';
        if (this.inCircle) styles.width = this.height + 'px';
        if (this.background) styles.backgroundColor = this.background;
        if (this.boxShadow) styles.boxShadow = this.boxShadow;
        if (this.borderColor) styles.borderColor = this.borderColor;
        return styles;
      }
    }
  })
</script>

<style lang="scss">
  .ui-inline-icon {
    display: inline-block;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    text-align: center;

    svg {
      height: 100%;
      width: auto;
    }

    &--circle {
      overflow: hidden;
      border-radius: 100%;
      display: inline-flex;
      justify-content: center;
      align-items: center;

      svg {
        max-height: 70%;
        max-width: 70%;
      }
    }
  }
</style>